// utils/favoritesAndHistoryApi.ts
// 新 Favorites API（rl_book_id ベース、api.readlinker.com/favorites）

import axios from 'axios';
import { NEW_API } from '../config/api';

const FAVORITES_URL = NEW_API.FAVORITES;

function authHeaders(idToken: string) {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
  };
}

/** お気に入り一覧取得（認証必要） */
export async function fetchFavoriteBooks(idToken: string) {
  const res = await axios.get(FAVORITES_URL, { headers: authHeaders(idToken) });
  return res.data; // { success, data: { items: [...] } }
}

/** 特定書籍がお気に入りか判定（認証必要） */
export async function checkIsFavorited(rlBookId: number, idToken: string) {
  const res = await axios.get(FAVORITES_URL, {
    headers: authHeaders(idToken),
    params: { rl_book_id: rlBookId },
  });
  return res.data; // { success, data: { is_favorited: boolean } }
}

/** お気に入り数を取得（認証不要） */
export async function fetchFavoriteCount(rlBookId: number) {
  const res = await axios.get(FAVORITES_URL, {
    params: { count_for_rl_book_id: rlBookId },
  });
  return res.data; // { success, data: { rl_book_id, count } }
}

/** お気に入りに追加（認証必要） */
export async function addFavoriteBook(rlBookId: number, idToken: string) {
  const res = await axios.post(
    FAVORITES_URL,
    { operation_type: 'add_favorite', rl_book_id: rlBookId },
    { headers: authHeaders(idToken) },
  );
  return res.data; // { success, data: { rl_book_id, favorited_at } }
}

/** お気に入りから削除（認証必要） */
export async function removeFavoriteBook(rlBookId: number, idToken: string) {
  const res = await axios.post(
    FAVORITES_URL,
    { operation_type: 'remove_favorite', rl_book_id: rlBookId },
    { headers: authHeaders(idToken) },
  );
  return res.data; // { success, data: { rl_book_id, removed } }
}
